import SchoolIcon from '@mui/icons-material/School';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import './Education.css';

const Education = () => (
  <section className="section education" id="education">
    <div className="container">
      <div className="education__grid">
        <div>
          <Reveal>
            <div className="section-head">
              <p className="section-eyebrow">Education</p>
              <h2 className="section-title">Academic foundation</h2>
              <p className="section-lead">
                Formal training in software engineering, complemented by industry certifications.
              </p>
            </div>
          </Reveal>

          <div className="education__list">
            {portfolioData.education.map((item, index) => (
              <Reveal key={item.degree} delay={index + 1}>
                <article className="education__item">
                  <div className="education__icon" aria-hidden="true">
                    <SchoolIcon />
                  </div>
                  <div>
                    <h3>{item.degree}</h3>
                    <p className="education__school">{item.school}</p>
                    <p className="education__meta">
                      {item.date}
                      {item.note ? ` · ${item.note}` : ''}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>

        <div id="certifications">
          <Reveal>
            <div className="section-head">
              <p className="section-eyebrow">Certifications</p>
              <h2 className="section-title">Continued learning</h2>
            </div>
          </Reveal>

          <div className="education__certs">
            {portfolioData.certifications.map((cert, index) => (
              <Reveal key={cert.title} delay={(index % 3) + 1}>
                <article className="education__cert">
                  <WorkspacePremiumIcon className="education__cert-icon" />
                  <div>
                    <h3>{cert.title}</h3>
                    <p>{cert.issuer}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Education;
